module.exports = __webpack_public_path__ + "media/virtual_show/vShowLogoLight-79423f87.png";